import { useEffect, useRef, useState } from "react";
import { motion } from "motion/react";
import { ImageWithFallback } from "./figma/ImageWithFallback";

const itineraries = [
	{
		id: 1,
		destination: "Japan",
		title: "Cherry Blossoms & Temples",
		image:
			"https://images.unsplash.com/photo-1680613854011-124796e44e54?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxqYXBhbiUyMGNoZXJyeSUyMGJsb3Nzb21zJTIwdGVtcGxlfGVufDF8fHx8MTc3MzY2MDIwOXww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 2,
		destination: "Santorini",
		title: "Greek Island Paradise",
		image:
			"https://images.unsplash.com/photo-1656504862933-8d29a68a9492?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzYW50b3JpbmklMjBncmVlY2UlMjBzdW5zZXR8ZW58MXx8fHwxNzczNzA3NzE2fDA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 3,
		destination: "Maldives",
		title: "Luxury Overwater Escape",
		image:
			"https://images.unsplash.com/photo-1637576308588-6647bf80944d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtYWxkaXZlcyUyMG92ZXJ3YXRlciUyMGJ1bmdhbG93fGVufDF8fHx8MTc3MzcwMzQ3OHww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 4,
		destination: "Patagonia",
		title: "Adventure in the Wild",
		image:
			"https://images.unsplash.com/photo-1674249283858-a9f4eea4beff?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwYXRhZ29uaWElMjBtb3VudGFpbnMlMjBsYW5kc2NhcGV8ZW58MXx8fHwxNzczNjcxODkxfDA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 5,
		destination: "Bali",
		title: "Rice Terraces & Culture",
		image:
			"https://images.unsplash.com/photo-1656247203824-3d6f99461ba4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxiYWxpJTIwcmljZSUyMHRlcnJhY2VzfGVufDF8fHx8MTc3Mzc0MDMxNHww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 6,
		destination: "Paris",
		title: "City of Lights",
		image:
			"https://images.unsplash.com/photo-1431274172761-fca41d930114?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwYXJpcyUyMGVpZmZlbCUyMHRvd2VyfGVufDF8fHx8MTc3MzczNTUwOXww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 7,
		destination: "Norway",
		title: "Fjords & Northern Lights",
		image:
			"https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxub3J3YXklMjBmanxlbnwxfHx8fDE3NzM2NjAyMDl8MA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 8,
		destination: "Iceland",
		title: "Northern Lights Adventure",
		image:
			"https://images.unsplash.com/photo-1488415032361-b7e238421f1b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpY2VsYW5kJTIwbm9ydGhlcm4lMjBsaWdodHN8ZW58MXx8fHwxNzczNzI1MjYxfDA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 9,
		destination: "Safari",
		title: "African Wildlife",
		image:
			"https://images.unsplash.com/photo-1578935028408-f9413a9c7356?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzYWZhcmklMjBhZnJpY2ElMjBlbGVwaGFudHN8ZW58MXx8fHwxNzczNzYxMzA3fDA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 10,
		destination: "New York",
		title: "Big Apple Experience",
		image:
			"https://images.unsplash.com/photo-1514565131-fce0801e5785?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxuZXclMjB5b3JrJTIwY2l0eSUyMHNreWxpbmV8ZW58MXx8fHwxNzczNjg2NDEwfDA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 11,
		destination: "Machu Picchu",
		title: "Ancient Incan Wonder",
		image:
			"https://images.unsplash.com/photo-1600913248959-c1752bdd05e3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwZXJ1JTIwbWFjaHUlMjBwaWNjaHV8ZW58MXx8fHwxNzczNzI1MjYyfDA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 12,
		destination: "Dubai",
		title: "Modern Luxury",
		image:
			"https://images.unsplash.com/photo-1657106251952-2d584ebdf886?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkdWJhaSUyMHNreWxpbmUlMjBuaWdodHxlbnwxfHx8fDE3NzM2MzY4MzN8MA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 13,
		destination: "Thailand",
		title: "Floating Markets & Beaches",
		image:
			"https://images.unsplash.com/photo-1706117040529-69ee35ad9aa3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0aGFpbGFuZCUyMGZsb2F0aW5nJTIwbWFya2V0fGVufDF8fHx8MTc3MzY1NzA2Nnww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 14,
		destination: "Switzerland",
		title: "Alpine Magic",
		image:
			"https://images.unsplash.com/photo-1506905925346-21bda4d32df4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzd2l0emVybGFuZCUyMGFscHN8ZW58MXx8fHwxNzM3MTQ2NDYyfDA&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 15,
		destination: "Morocco",
		title: "Sahara & Souks",
		image:
			"https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb3JvY2NvJTIwZGVzZXJ0fGVufDF8fHx8MTczNzE0NjQ2Mnww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 16,
		destination: "New Zealand",
		title: "Hobbiton & Glaciers",
		image:
			"https://images.unsplash.com/photo-1507699622108-4be3abd695ad?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxuZXclMjB6ZWFsYW5kJTIwbW91bnRhaW5zfGVufDF8fHx8MTczNzE0NjQ2Mnww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 17,
		destination: "Vietnam",
		title: "Halong Bay Cruise",
		image:
			"https://images.unsplash.com/photo-1583417319070-4a69db38a482?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx2aWV0bmFtJTIwaGFsb25nJTIwYmF5fGVufDF8fHx8MTczNzE0NjQ2Mnww&ixlib=rb-4.1.0&q=80&w=1080",
	},
	{
		id: 18,
		destination: "Italy",
		title: "Tuscan Countryside",
		image:
			"https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpdGFseSUyMHR1c2NhbnklMjBjb3VudHJ5c2lkZXxlbnwxfHx8fDE3MzcxNDY0NjJ8MA&ixlib=rb-4.1.0&q=80&w=1080",
	},
];

export function ItineraryShowcase() {
	const containerRef = useRef<HTMLDivElement>(null);
	const [scrollY, setScrollY] = useState(0);

	useEffect(() => {
		const handleScroll = () => {
			if (!containerRef.current) return;

			const rect = containerRef.current.getBoundingClientRect();
			const scrollProgress = -rect.top / (rect.height - window.innerHeight);
			const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

			setScrollY(clampedProgress);
		};

		window.addEventListener("scroll", handleScroll);
		handleScroll();

		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	// Split itineraries into two rows and duplicate for infinite scroll
	const row1 = itineraries.slice(0, 9);
	const row2 = itineraries.slice(9, 18);

	return (
		<div ref={containerRef} className="relative bg-gray-50" style={{ height: "300vh" }}>
			<div className="sticky top-0 h-screen flex items-center justify-center overflow-hidden py-8">
				<div className="container mx-auto max-w-7xl px-6">
					{/* Section Header */}
					<motion.div
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ duration: 0.6 }}
						className="text-center mb-8 md:mb-16"
					>
						<p className="text-sm font-semibold tracking-wide mb-3 uppercase" style={{ color: "#8B5CF6" }}>
							BUILT WITH STIPPL
						</p>
						<h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" style={{ color: "#0F3E4A", fontFamily: "Poppins, sans-serif" }}>
							This is what your proposals could look like
						</h2>
						<p className="text-base md:text-lg max-w-4xl mx-auto leading-relaxed" style={{ color: "#6B7280" }}>
							Pick your destination, see how Stippl makes it stunning.
						</p>
					</motion.div>

					{/* Scrolling rows */}
					<div className="space-y-6">
						{/* Row 1 - moves left */}
						<motion.div
							className="flex gap-6 px-6"
							style={{
								x: -scrollY * 800 - (80 + 24) * 9,
							}}
						>
							{[...row1, ...row1, ...row1].map((itinerary, index) => (
								<button
									key={`row1-${index}`}
									type="button"
									className="flex-shrink-0 w-80 h-48 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 relative group"
								>
									<ImageWithFallback src={itinerary.image} alt={itinerary.destination} className="w-full h-full object-cover" loading="lazy" />
									<div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex flex-col justify-end p-6">
										<h3 className="text-white text-xl font-bold mb-1">{itinerary.destination}</h3>
										<p className="text-white/90 text-sm">{itinerary.title}</p>
									</div>
								</button>
							))}
						</motion.div>

						{/* Row 2 - moves right */}
						<motion.div
							className="flex gap-6 px-6"
							style={{
								x: scrollY * 800 - (80 + 24) * 9,
							}}
						>
							{[...row2, ...row2, ...row2].map((itinerary, index) => (
								<button
									key={`row2-${index}`}
									type="button"
									className="flex-shrink-0 w-80 h-48 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 relative group"
								>
									<ImageWithFallback src={itinerary.image} alt={itinerary.destination} className="w-full h-full object-cover" loading="lazy" />
									<div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex flex-col justify-end p-6">
										<h3 className="text-white text-xl font-bold mb-1">{itinerary.destination}</h3>
										<p className="text-white/90 text-sm">{itinerary.title}</p>
									</div>
								</button>
							))}
						</motion.div>
					</div>
				</div>
			</div>
		</div>
	);
}
